import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  link: {
    textDecoration: 'none',
    transition: 'color 0.2s',
    color: {
      'default': colors.grey600,
      ':hover': colors.grey900,
    },
  },
  text: (active: boolean) => ({
    color: {
      'default': colors[`grey${active ? '900' : '600'}`],
      ':hover': colors.grey900,
    },
  }),
})

interface SidebarItemProps {
  to: string
  value: string
  active: boolean
  onClick?: () => void
}

export const SidebarItem = ({ active, to, value, onClick }: SidebarItemProps) => {
  return (
    <a {...stylex.props(styles.link)} href={to}>
      <Box py={2} px={4} backgroundColor={colors.grey50} onClick={onClick}>
        <Text variant="body" rootStyle={styles.text(active)}>{value}</Text>
      </Box>
    </a>
  )
}
